import Select from 'react-select/creatable'
import { selectStyles } from 'apps/builder/components/shared'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { BasicMoreSettings } from './BasicMoreSettings'
import UnsecuredAccessToggle from 'apps/builder/components/shared/unsecuredAccessToggle';

export const VideoMoreSettings = entry => {
  return (
    <>
      <div className="settings--row">
        <VideoSourceDropdown {...entry} />
        <UnsecuredAccessToggle guid={entry.guid} allow_unsecured_access={entry.allow_unsecured_access} mediaType="videos" />
      </div>
      <BasicMoreSettings
        mobileVisible={true}
        pageBreakAfter={false}
        placeValueIn={false}
        {...entry}
      />
    </>
  )
}

const VideoSourceDropdown = ({ guid }) => {
  const options = [
    {
      label: 'Camera Only',
    }
  ]

  return (
    <div className="settings--field-type">
      <Select
        styles={selectStyles}
        className="input--placeholder"
        classNamePrefix="react-select"
        value={options[0]}
        options={options}
        onChange={({ value }) => {
          dispatch(
            updateEntry({
              guid,
              mask: value,
            })
          )
        }}
      />
      <label>Video Source</label>
    </div>
  )
}
